export default __webpack_public_path__ + "static/poster-7c9a24db0bf10752f6808fd4841fa8cf.png";